import { render, staticRenderFns } from "./ConfirmationMessage.vue?vue&type=template&id=ca9a0af4&"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports